import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class NumeroDocumentoService {

  matchPassword(numeroDocumento: string, confirmNumeroDocumento: string) {
    return (formGroup: UntypedFormGroup) => {
      const control = formGroup.controls[numeroDocumento];
      const matchingControl = formGroup.controls[confirmNumeroDocumento];

      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ confirmNumeroDocumentoMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    }
  }
}